import { render, staticRenderFns } from "./smart_claims.vue?vue&type=template&id=31254422&scoped=true&"
import script from "./smart_claims.vue?vue&type=script&lang=js&"
export * from "./smart_claims.vue?vue&type=script&lang=js&"
import style0 from "./smart_claims.vue?vue&type=style&index=0&id=31254422&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31254422",
  null
  
)

export default component.exports